import React, { useState } from "react";

const MilestonePanel = ({ milestones, setMilestones, activeMetric }) => {
  const [newMilestone, setNewMilestone] = useState({
    metric: activeMetric,
    date: "",
    value: ""
  });

  return (
    <div className="milestone-panel" style={{ marginTop: "24px" }}> {/* Added more top margin */}
      <h4 style={{ marginBottom: "12px" }}>Milestones</h4>

      <div className="milestone-table">
        {/* Table Header */}
        <div className="table-header">
          <div>Metric</div>
          <div>Date</div>
          <div>Value</div>
          <div>Action</div>
        </div>

        {/* Input Row (as first table row) */}
        <div className="table-row input-row">
          <div>
            <select
              value={newMilestone.metric}
              onChange={(e) => setNewMilestone({ ...newMilestone, metric: e.target.value })}
            >
              <option value="Heart Rate">Heart Rate</option>
              <option value="Weight">Weight</option>
              <option value="BP">Blood Pressure</option>
              <option value="PHQ-9 (Depression)">PHQ-9 (Depression)</option>
              <option value="GAD-7 (Anxiety)">GAD-7 (Anxiety)</option>
            </select>
          </div>
          <div>
            <input
              type="date"
              value={newMilestone.date}
              onChange={(e) => setNewMilestone({ ...newMilestone, date: e.target.value })}
            />
          </div>
          <div>
            <input
              type="text"
              placeholder="Target"
              value={newMilestone.value}
              onChange={(e) => setNewMilestone({ ...newMilestone, value: e.target.value })}
            />
          </div>
          <div>
            <button
              onClick={() => {
                if (newMilestone.date && newMilestone.value) {
                  setMilestones([...milestones, {
                    ...newMilestone,
                    status: "Pending"
                  }]);
                  setNewMilestone({
                    metric: activeMetric,
                    date: "",
                    value: ""
                  });
                }
              }}
            >
              Add
            </button>
          </div>
        </div>

        {/* Existing Milestones */}
        {milestones.map((m, i) => (
          <div key={i} className={`table-row ${m.status.toLowerCase()}`}>
            <div>{m.metric}</div>
            <div>{m.date}</div>
            <div>{m.value}</div>
            <div>{m.status}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MilestonePanel;